export var BadgeType;
(function (BadgeType) {
    BadgeType["DEFAULT"] = "default";
    BadgeType["DANGER"] = "danger";
    BadgeType["OFFER"] = "offer";
    BadgeType["SUCCESS"] = "success";
    BadgeType["WARNING"] = "warning";
    BadgeType["NEUTRAL"] = "neutral";
    BadgeType["GREEN"] = "green";
    BadgeType["VALUE_GREEN"] = "valueGreen";
    BadgeType["SEASONAL"] = "seasonal";
    BadgeType["LIMITED_EDITION"] = "limitedEdition";
    BadgeType["WINE_EVENT"] = "wineEvent";
})(BadgeType || (BadgeType = {}));
//# sourceMappingURL=types.js.map